module.exports = __webpack_public_path__ + "img/マイナスのアイコン素材.fdef243b.svg";